import { route } from "quasar/wrappers";
import { createRouter, createWebHistory } from "vue-router";
import { Cookies } from "quasar";
import routes from "./routes";
import { AppAuthTokenKey } from "@/libs/constant";
import { useSSRContext } from "vue";
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route((/* = { store, ssrContext } */) => {
  const createHistory = createWebHistory;
  const ssrContext = process.env.SERVER ? useSSRContext() : null;
  const cookies = process.env.SERVER ? Cookies.parseSSR(ssrContext) : Cookies;
  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });
  Router.beforeEach((to, from, next) => {
    const token = cookies.get(AppAuthTokenKey);
    if (token && to.meta.onlyGuest) {
      next("/");
    } else {
      next();
    }
  });
  return Router;
});
